import React from "react";
import SelectDropdown from "./shared/SelectDropdown";

const ALL_ENTITIES = "__all__";

const SubmissionEntitySelector = ({ entityIds, selectedEntity, setSelectedEntity }) => {
  const handleChange = (value) => setSelectedEntity(value === ALL_ENTITIES ? null : value);

  const options = [
    { value: ALL_ENTITIES, label: "All Entities" },
    ...entityIds.map((id) => ({
      key: id,
      value: id,
      label: id,
    })),
  ];

  return (
    <SelectDropdown
      options={options}
      value={selectedEntity ?? ALL_ENTITIES}
      onChange={handleChange}
    />
  );
};

export default SubmissionEntitySelector;
